import type { SVGProps } from 'react';

export const Search = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.525 15.625c-1.717 0-3.167-.592-4.35-1.775C3.992 12.65 3.4 11.2 3.4 9.5c0-1.7.592-3.142 1.775-4.325 1.183-1.2 2.633-1.8 4.35-1.8 1.7 0 3.142.6 4.325 1.8C15.033 6.358 15.625 7.8 15.625 9.5c0 .717-.117 1.4-.35 2.05a5.612 5.612 0 0 1-.95 1.7l5.75 5.75a.71.71 0 0 1 .2.525c0 .2-.067.375-.2.525a.748.748 0 0 1-.55.225.641.641 0 0 1-.5-.225L13.25 14.3c-.5.417-1.075.742-1.725.975-.65.233-1.317.35-2 .35Zm0-1.5c1.283 0 2.367-.45 3.25-1.35.9-.9 1.35-1.992 1.35-3.275s-.45-2.375-1.35-3.275c-.883-.9-1.967-1.35-3.25-1.35-1.3 0-2.4.45-3.3 1.35C5.342 7.125 4.9 8.217 4.9 9.5s.442 2.375 1.325 3.275c.9.9 2 1.35 3.3 1.35Z" />
    </svg>
  );
};
